import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../scripts/api";
import axiosInstance from "../../scripts/axiosInspector";
import HeaderReq from "../../scripts/functions/headerReq";

const AutoSearch = ({
  value,
  onChange,
  label,
  err,
  inputValue,
  setInputValue,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);
  const [options, setOption] = useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const dispatch = useDispatch();

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (inputValue)
        if (userInfo) {
          setLoading(true);
          setHasChecked(false);
          if (inputValue && inputValue !== "undefined" && !hasChecked) {
            axiosInstance
              .get(
                API.public.stuff + `?chSearchValue=${inputValue}`,
                HeaderReq(userInfo?.token)
              )
              .then((res) => {
                setOption(res?.data?.data);
                setLoading(false);
              })
              .catch((err) => {
                setLoading(false);
              });
          } else {
            setOption([]);
            setLoading(false);
            /*   if (err.response.status === 401 || err.response.status === 403) {
              dispatch(handleLogOut());
            } */
          }
        }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [userInfo, inputValue]);
  return (
    <div>
      {" "}
      <Autocomplete
        id="asynchronous-demo"
        inputValue={inputValue && inputValue !== "undefined" ? inputValue : ""}
        /*         onInputChange={(event, newInputValue) => {
        
       
        }} */
        value={value && value !== "undefined" ? value : ""}
        onChange={(event, newValue) => {
          if (newValue && newValue !== "undefined") {
            onChange(newValue);
            setInputValue(`ECU : ${newValue.chCode}, ${newValue.chName}`);
            setHasChecked(true);
          }
        }}
        isOptionEqualToValue={(option, value) =>
          `ECU : ${option.chCode}, ${option.chName}` ===
          `ECU : ${value.chCode}, ${option.chName}`
        }
        getOptionLabel={(option) => `ECU : ${option.chCode}, ${option.chName}`}
        options={options}
        loading={loading}
        noOptionsText="مورد یافت نشد"
        loadingText="در حال جست و جو ..."
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            fullWidth
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={() => {
              setOpen(true);
            }}
            error={err || (open && !value)}
            helperText={
              (err || (open && !value)) && (
                <div className="text-left">
                  {"این فیلد را به درستی پر کنید"}
                </div>
              )
            }
            placeholder="جست و جو ..."
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </div>
  );
};

export default AutoSearch;
